// extracted by mini-css-extract-plugin
export var desktop = "header-module--desktop--8223e";
export var genericContainer = "header-module--genericContainer--96722";
export var mobile = "header-module--mobile--73ae0";